import { render, staticRenderFns } from "./npsScale.vue?vue&type=template&id=0fc76c76&scoped=true&"
import script from "./npsScale.vue?vue&type=script&lang=ts&"
export * from "./npsScale.vue?vue&type=script&lang=ts&"
import style0 from "./npsScale.vue?vue&type=style&index=0&id=0fc76c76&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc76c76",
  null
  
)

export default component.exports